import { useEffect } from 'react';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";

import FilterableTable from 'components/Admin/ObjectTable';

import { fetchActionItems } from 'Redux/Admin/ProjectManager/ActionItems/action';

import rootReducer from 'Redux/root-reducer';

import type { TableColumnsType } from 'antd';
import type { FilterConfig } from '@types';
import type { IActionItem } from 'Redux/Admin/ProjectManager/ActionItems/type';

import { ADMIN_PATH } from "utils/routes";

type RootState = ReturnType<typeof rootReducer>;

const columns: TableColumnsType<IActionItem> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`${ADMIN_PATH}/project-manager/action-items/${record.id}`}>{record.id}</Link>
      </Space>
    ),
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 280,
  },
  {
    title: 'Weight',
    dataIndex: 'weight',
    key: 'weight',
    width: 180,
  },
  {
    title: 'Category Progress',
    dataIndex: 'category_progress',
    key: 'category_progress',
    width: 180,
  },
  {
    title: 'Plan Progress',
    dataIndex: 'plan_progress',
    key: 'plan_progress',
    width: 180,
  },
  {
    title: 'Start Line',
    dataIndex: 'start_line',
    key: 'start_line',
    width: 180,
  },
  {
    title: 'Dead Line',
    dataIndex: 'dead_line',
    key: 'dead_line',
    width: 180,
  },
  {
    title: 'Responsible Person',
    dataIndex: 'responsible_person',
    key: 'responsible_person',
    width: 180,
  },
];

const ActionItems = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const category = params.get('category');
  const pageValue = parseInt(params.get('page') || '1');

  const { entities, ids, count, loading } = useSelector((state: RootState) => state.fetchActionItems);

  useEffect(() => {
    dispatch(fetchActionItems({ category, offset: (pageValue - 1) * 50, limit: 50 }, () => {}));
  }, [category, pageValue, dispatch]);

  // Build filter configs for this page
  const filterConfigs: FilterConfig[] = [
    {
      type: 'search',
      paramName: 'search',
      label: 'Search',
      placeholder: 'Search by name'
    },
    {
      type: 'project-action-category-select',
      paramName: 'category',
      placeholder: 'Select action category...',
      label: 'Action Category'
    },
  ];

  const dataItems = ids.map(id => entities[id]);

  return (
    <FilterableTable<IActionItem>
      columns={columns}
      data={dataItems}
      loading={loading}
      totalItems={count}
      createLink={`${ADMIN_PATH}/project-manager/action-items/new`}
      filters={filterConfigs}
    />
  );
}

export default ActionItems;
